//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
export default {
  name: 'StockOutPlanList',
  components: {
    CyMobileLayout
  },
  data () {
    return {
      recordList: [{}]
    }
  },
  mounted () {
    this.queryPlanList()
  },
  methods: {
    queryPlanList: function () {
      let that = this
      let url = '/wms/stockout/plan/getStockOutPlanListOfUnOut'
      that.$axiosWeb.post(url).then(function (res) {
        if (res.meta.success) {
          that.recordList = res.data
        } else {
          that.$Msgbox.alert(res.meta.message, '查询失败')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockout/StockOutPlanList.vue